import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Output, EventEmitter } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select-box-example.component.html',
  styleUrls: ['./multi-select-box-example.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
})
export class MultiSelectBoxExampleComponent implements OnInit {

  constructor(private projectsService : ProjectsService){}
  projectTypeControl = new FormControl('');
  projectTypes: string[] = [
    'Roaad & Runway',
    'Buildings',
    'Sewrage Lines',
    'Hospital',
  ];

  selectedType:any;
  selectedSubType:any;
  projectsType:any;
  projectsSubType:any;

  filteredprojectTypes!: Observable<string[]>;

  showDropdown = false;
  showCategoryDropdown = false;

  @Output() contentChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() removeContent: EventEmitter<string> = new EventEmitter<string>();
  ngOnInit() {

    this.filteredprojectTypes = this.projectTypeControl.valueChanges.pipe(
      startWith(''), // Emit initial value
      map((value) => this.filterprojectTypes(value || '')) // Map the input value to the filtered projectTypes
    );
  }

  private filterprojectTypes(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.projectTypes.filter((projectType) =>
      projectType.toLowerCase().includes(filterValue)
    );
  }

  onSelectionTypeChange(option: string) {
    this.selectedType = option;
    // this.getSubTypes();
  }

  onSelectionSubTypeChange(option: string) {
    this.selectedSubType = option;
  }


  addProjectType(option: string) {

      this.projectTypes.push(option);
      this.selectedType = option;
    this.projectTypeControl.setValue('');
    this.showDropdown = false;
  }

  addProjectSubType(option: string) {

    this.projectTypes.push(option);
    this.selectedSubType = option;
    this.projectTypeControl.setValue('');
    this.showDropdown = false;
}


  onTypeFocus() {
    this.showDropdown = true;
  }

  onSubTypeFocus() {
    this.showCategoryDropdown = true;
  }

  onBlur() {
    setTimeout(() => {
      this.showDropdown = false;
      this.showCategoryDropdown = false;
    }, 200);
  }
}
